import React, { useState, useEffect } from 'react';
import * as LucideIcons from 'lucide-react';
import { useAppContext } from '../AppContext';
import { useTranslation } from 'react-i18next';

const ConstellationSettingsModal = ({ currentSettings, onSave, onClose }) => {
    const { t } = useTranslation();
    const { currentUserProfile } = useAppContext();
    const [settings, setSettings] = useState(currentSettings);

    const handleChange = (param, value) => {
        setSettings(prev => ({ ...prev, [param]: parseFloat(value) }));
    };

    const handleSave = () => {
        onSave(settings);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex justify-center items-center animate-fadeIn a-short-delay" onClick={onClose}>
            <div className="bg-gray-800 rounded-xl shadow-lg w-full max-w-md m-4 border border-gray-700" onClick={(e) => e.stopPropagation()}>
                <div className="p-6 border-b border-gray-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-white">{t('constellationSettings.title')}</h2>
                    <button onClick={onClose} className="ai-icon-button text-gray-400 hover:bg-white/10">
                        <LucideIcons.X size={24} />
                    </button>
                </div>
                <div className="p-6 space-y-4">
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-300 mb-1">{t('constellationSettings.spread')}: {settings.dynamicRadiusMultiplier.toFixed(1)}</label>
                        <input type="range" min="0.5" max="5.0" step="0.1" value={settings.dynamicRadiusMultiplier} onChange={(e) => handleChange('dynamicRadiusMultiplier', e.target.value)} className="w-full" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-300 mb-1">{t('constellationSettings.rotationSpeed')}: {settings.autoRotateSpeed.toFixed(1)}</label>
                        <input type="range" min="0.0" max="5.0" step="0.1" value={settings.autoRotateSpeed} onChange={(e) => handleChange('autoRotateSpeed', e.target.value)} className="w-full" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-300 mb-1">{t('constellationSettings.starPulseIntensity')}: {settings.starPulseIntensity.toFixed(2)}</label>
                        <input type="range" min="0.0" max="0.5" step="0.01" value={settings.starPulseIntensity} onChange={(e) => handleChange('starPulseIntensity', e.target.value)} className="w-full" />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm text-gray-300 mb-1">{t('constellationSettings.bloomEffect')}: {settings.bloomIntensity.toFixed(1)}</label>
                        <input type="range" min="0.0" max="5.0" step="0.1" value={settings.bloomIntensity} onChange={(e) => handleChange('bloomIntensity', e.target.value)} className="w-full" />
                    </div>
                </div>
                <div className="p-6 border-t border-gray-700 flex justify-end">
                    <button onClick={handleSave} className="small-action-button bg-blue-600 hover:bg-blue-700">
                        <LucideIcons.Save size={16} className="mr-2" /> {t('constellationSettings.save')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConstellationSettingsModal;
